const breakpointMixin = {
  data() {
    return {
      breakpoints: ['xs', 'sm', 'md', 'lg', 'xl'],
    }
  },
  methods: {
    // parse breakpoint string
    // return object containing breakpoint values
    parseBreakpoints(string) {
      if (!string) return

      const result = {}

      this.breakpoints.forEach((breakpoint, index) => {
        const regex = new RegExp(`${breakpoint}-\\[(.*?)\\]`)
        const match = string.match(regex)
        if (match && match[1]) {
          result[breakpoint] = match[1]
        } else {
          result[breakpoint] = result[this.breakpoints[index - 1]]
        }
      })

      return result
    },
    // return current breakpoint
    getBreakpointValue(string) {
      if (!string) return
      if (!this.$mq) return console.warn('Missing $mq plugin')

      const breakpoints = this.parseBreakpoints(string)

      const targetBreakpoint = breakpoints?.[this.$mq]

      // console.log(breakpoints, targetBreakpoint, this.$mq)

      return targetBreakpoint
    },
  },
}

export default breakpointMixin
